import { environment } from '../../../../environments/environments';

export function AxiosRequestInterceptor(config) {
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.split('=').map((item) => item.trim());
        acc[key] = value;
        return acc;
      }, {});
      const appVar = String(environment?.appVar ?? '').trim();
      const prefixedKey = appVar ? `${appVar}_accessToken` : 'accessToken';
      const token = cookies[prefixedKey] || cookies['accessToken'];
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
}
